const MESSAGE_READ_UI_SYNC_DELAY_MS = 4000;

let suppressUnreadCountsFetchUntil = 0;
let readUiSyncTimer = null;
let deferredUnreadCountsFetchTimer = null;
let pendingUnreadCountsFetch = null;

export { MESSAGE_READ_UI_SYNC_DELAY_MS };

export function beginConversationReadUiSync() {
  suppressUnreadCountsFetchUntil = Date.now() + MESSAGE_READ_UI_SYNC_DELAY_MS;

  if (readUiSyncTimer) {
    clearTimeout(readUiSyncTimer);
  }

  readUiSyncTimer = setTimeout(() => {
    readUiSyncTimer = null;
    suppressUnreadCountsFetchUntil = 0;
  }, MESSAGE_READ_UI_SYNC_DELAY_MS);
}

export function cancelConversationReadUiSync() {
  if (readUiSyncTimer) {
    clearTimeout(readUiSyncTimer);
    readUiSyncTimer = null;
  }

  suppressUnreadCountsFetchUntil = 0;
  pendingUnreadCountsFetch = null;

  if (deferredUnreadCountsFetchTimer) {
    clearTimeout(deferredUnreadCountsFetchTimer);
    deferredUnreadCountsFetchTimer = null;
  }
}

export function shouldDeferUnreadCountsFetch() {
  return Date.now() < suppressUnreadCountsFetchUntil;
}

export function deferUnreadCountsFetchRemainingMs() {
  return Math.max(0, suppressUnreadCountsFetchUntil - Date.now());
}

export function isConversationReadUiSyncPending() {
  return readUiSyncTimer !== null;
}

export function scheduleConversationReadUiSync(callback) {
  const remainingMs = deferUnreadCountsFetchRemainingMs();

  if (readUiSyncTimer) {
    clearTimeout(readUiSyncTimer);
    readUiSyncTimer = null;
  }

  if (remainingMs <= 0) {
    suppressUnreadCountsFetchUntil = 0;
    callback();
    return;
  }

  readUiSyncTimer = setTimeout(() => {
    readUiSyncTimer = null;
    suppressUnreadCountsFetchUntil = 0;
    callback();
  }, remainingMs);
}

export function requestConversationUnreadCountsRefresh(fetchFn) {
  if (typeof fetchFn !== 'function') return;

  const remainingMs = deferUnreadCountsFetchRemainingMs();
  if (remainingMs <= 0) {
    fetchFn();
    return;
  }

  if (isConversationReadUiSyncPending()) {
    return;
  }

  pendingUnreadCountsFetch = fetchFn;

  if (deferredUnreadCountsFetchTimer) return;

  deferredUnreadCountsFetchTimer = setTimeout(() => {
    deferredUnreadCountsFetchTimer = null;
    suppressUnreadCountsFetchUntil = 0;

    const fetchCallback = pendingUnreadCountsFetch;
    pendingUnreadCountsFetch = null;
    fetchCallback?.();
  }, remainingMs);
}
